import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BORDER_GRAY } from 'constants/colors';
export default makeStyles(theme => {
  return createStyles({
    divider: {
      margin: theme.spacing(3, 0),
      backgroundColor: BORDER_GRAY
    }
  });
});